"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var iPhone = exports.iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
var iPod = exports.iPod = /iPod/.test(navigator.userAgent) && !window.MSStream;
var iPad = exports.iPad = /iPad/.test(navigator.userAgent) && !window.MSStream;
var Android = exports.Android = /(android)/i.test(navigator.userAgent);
//# sourceMappingURL=device-detection.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/utils/device-detection.js
// module id = 1234
// module chunks = 1 2 3